import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';

// Initialize Sentry for error tracking
// Only initialize if DSN is provided (production)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
    Sentry.init({
        dsn: sentryDsn,
        environment: import.meta.env.MODE || 'development',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of transactions in production
        // Session Replay
        replaysSessionSampleRate: 0.1, // Sample 10% of sessions
        replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
    });
    console.log('✅ Sentry initialized for error tracking');
}
// Sentry not configured - no error tracking during beta

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    // Only use StrictMode in development
    root.render(
        import.meta.env.DEV ? (
            <React.StrictMode>
                <App />
            </React.StrictMode>
        ) : (
            <App />
        )
    );
} else {
    const errorMsg = "Fatal Error: Root element '#root' not found in the DOM.";
    console.error(errorMsg);

    // Report to Sentry if available
    if (sentryDsn) {
        Sentry.captureException(new Error(errorMsg));
    }

    // Safely create error message without innerHTML (prevents XSS)
    const errorContainer = document.createElement('div');
    errorContainer.style.cssText = 'color: #c00; max-width: 560px; margin: 2rem auto; font-family: system-ui; text-align: center;';

    const errorHeading = document.createElement('h1');
    errorHeading.textContent = 'Fatal Error';

    const errorText = document.createElement('p');
    errorText.textContent = 'Application mount point not found. Contact support.';

    errorContainer.appendChild(errorHeading);
    errorContainer.appendChild(errorText);
    document.body.appendChild(errorContainer);
}
